import React from 'react';
import './average-rating.scss';

const AverageRating = ({ starNumber, progress, votesFrom, votesTo }) => {
    return (
        <div className="f-average-rating">
            <label className="f-average-rating-star-number">{starNumber}</label>
            <div className="f-average-rating-progress">
                <span className="f-average-rating-progress-indicator" style={{width: `${progress}%`}} />
            </div>
            <label className="f-average-rating-votes">{votesFrom} votos / {votesTo}</label>
        </div>
    )
}

export default AverageRating;
